import { useEffect, useLayoutEffect, useState } from 'react';

import { IUseFabric } from './types';

interface IUseCursor extends IUseFabric {
  defaultCursor: string;
}

export const useCursor = (props: IUseCursor) => {
  const { ref, context, defaultCursor } = props;
  const { annotationEnabled, zoom, mode } = context;
  const [isMouseDown, setMouseDown] = useState(false)

  let cursor = defaultCursor;

  if (zoom > 1) {
    cursor = 'grab';
  }

  if (isMouseDown && (zoom > 1 || defaultCursor === 'grab')) {
    cursor = 'grabbing';
  }

  if (annotationEnabled) {
    cursor = mode === 'rect' ? 'crosshair' : mode === 'text' ? 'text' : 'default';
  }

  useEffect(() => {
    const canvas = ref.current;
    const handleMouseDown = () => {
      setMouseDown(true);
    }
    const handleMouseUp = () => {
      setMouseDown(false);
    }
    canvas.on('mouse:down', handleMouseDown);
    canvas.on('mouse:up', handleMouseUp);
    return () => {
      canvas.off('mouse:down', handleMouseDown);
      canvas.on('mouse:up', handleMouseUp);
    }
  }, [ref]);

  useLayoutEffect(() => {
    const canvas = ref.current;
    canvas.defaultCursor = cursor;
    canvas.requestRenderAll();
  }, [cursor, ref]);
}
